import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllProfessionalsSelectOptionsUseCaseInterface } from 'domain/usecases';
import { IProfessionalsWorkJourneyFilters } from 'presentation/app/modules/Reports/models/professionals-work-journey-filters';

interface IProfessionalsWorkJourneyState {
  professionalsSelectOptions: GetAllProfessionalsSelectOptionsUseCaseInterface.Result;
  filters: IProfessionalsWorkJourneyFilters;
}

interface IPayloadProfessionalsSelectOptions
  extends PayloadAction<GetAllProfessionalsSelectOptionsUseCaseInterface.Result> {}

interface IPayloadProfessionalsWorkJourneyFilters
  extends PayloadAction<IProfessionalsWorkJourneyFilters> {}

const initialState: IProfessionalsWorkJourneyState = {
  professionalsSelectOptions: [],
  filters: null,
};

export const ProfessionalsWorkJourneySlice = createSlice({
  name: 'professionals-work-journey',
  initialState,
  reducers: {
    loadProfessionalsSelectOptions: (
      state,
      action: IPayloadProfessionalsSelectOptions,
    ) => {
      state.professionalsSelectOptions = action.payload;
    },
    loadFilters: (state, action: IPayloadProfessionalsWorkJourneyFilters) => {
      state.filters = action.payload;
    },
    clearFilters: (state) => {
      state.filters = null;
    },
  },
});

export const { loadFilters, loadProfessionalsSelectOptions } =
  ProfessionalsWorkJourneySlice.actions;

export default ProfessionalsWorkJourneySlice.reducer;
